<div class="flow-component">
    @if (sharedService.isDeletePending) {
    <div class="error-msg">
        View only mode. Pending Deletion
    </div>
    }
    <div #flowComponent [ngClass]="{ useFlexBox: !isScrollZoom, useBox: isScrollZoom }">
        <ng-container>
            <div class="toolbar" id="toolBar" [ngClass]="activeMode === 'PREVIEW_MODE' ? 'hideToolbar' : 'showToolbar'">
                <div class="toolbar_leftBox">
                    <!-- <button class="toolbar_flowNavBtn svgSprite icon_flow-black"></button> -->
                    <ul class="toolbar_controlList">
                        <!-- <li class="controlListItem svgSprite">
                                        <span class="controlListItem_iconBackground svgSprite icon_full-window"></span>
                                        <span class="controlListItem_label">Standard Screen</span>
                                      </li> -->

                        @if (sharedService.getEnvironment() != 'prod' && displayPreviewButton) {
                        <li class="controlListItem" (click)="openPreview()">
                            <span class="controlListItem_iconBackground">
                                <img class="controlListItem_icon" src='../../../assets/svg/flow-preview-icon.svg' />
                            </span>
                            <span class="controlListItem_label">Preview</span>
                        </li>
                        }
                        @if (canEdit() && !displayOnTemplate()) {
                        <li class="controlListItemSave"
                            (click)="requestSaveFlow()"
                            [ngClass]="canSaveFlow() ? 'controlListItemSave_greyedOut inactive' : ''">
                            <span class="controlListItem_iconBackground">
                                <img class="controlListItem_icon" src='../../../assets/svg/save-flow-icon.svg' />
                            </span>
                            <span class="controlListItem_label">Save Flow</span>
                        </li>
                        }

                        @if (displayOnTemplate()) {
                            @if (canEdit() && activeFlowPath !== '__NEW_FLOW__') {
                            <li class="controlListItemSave"
                                (click)="requestSaveFlow()"
                                [ngClass]="canSaveFlow() ? 'controlListItemSave_greyedOut inactive' : ''">
                                <span class="controlListItem_iconBackground">
                                    <img class="controlListItem_icon" src='../../../assets/svg/save-flow-icon.svg' />
                                </span>
                                <span class="controlListItem_label">Save Template</span>
                            </li>
                            }

                            @if (activeFlowPath === '__NEW_FLOW__') {
                            <li class="controlListItemSave">
                                <span class="controlListItem_iconBackground">
                                    <img class="controlListItem_icon" src='../../../assets/svg/save-flow-icon.svg' />
                                </span>
                                <span class="controlListItem_label" (click)="openExistingBotModal()">Save To Existing Bot</span>
                            </li>
                            }

                            @if (activeFlowPath === '__NEW_FLOW__') {
                            <li
                                class="controlListItemSave"
                                (click)="showSaveNewBotModal()">
                                <span class="controlListItem_iconBackground">
                                    <img class="controlListItem_icon" src='../../../assets/svg/save-flow-icon.svg' />
                                </span>

                                <span class="controlListItem_label">Save To New Bot</span>
                            </li>
                            }

                            <li class="controlListItemSave"
                                (click)="showManagePlaceholderModal()">
                                <span class="controlListItem_iconBackground">
                                    <img class="controlListItem_icon" src='../../../assets/svg/Union.svg' />
                                </span>
                                <span class="controlListItem_label">Manage Placeholders</span>

                            </li>

                        }
                        <li class="controlListItem" id="searchForStep"
                            [ngClass]="currentFlowSteps?.length !== 0 && activeMode !== 'SEARCH_MODE' ? 'search' : 'search-disable'"
                            (click)="searchBarDisplay()">
                        </li>
                        @if (isInternalUser()) {
                        <li class="controlListItem toggleButton">
                            <label class="toggleSwitch">
                                <input type="checkbox" (change)="toggleView($event)">
                                <span class="slider"></span>
                            </label>
                            <span class="controlListItem_label">
                                Show Code <span class="beta-label">(BETA Version)</span>
                            </span>
                        </li>
                        }
                        @if (showCodeView) {
                        <li class="controlListItem applyButton">
                            <button class="controlListItem_label apply-changes-button"
                                    [disabled]="!isCodeModified"
                                    (click)="applyCodeChangesHandler()">
                                Apply Changes
                            </button>
                        </li>
                        }
                    </ul>
                </div>
                <div class="toolbar_rightBox">
                    <ul class="toolbar_controlList" matTooltip="{{tooltipText}}" matTooltipPosition="below"
                        matTooltipClass="loop-tooltip">
                        @if (hasClickatellAiFlag) {
                        <li
              class="controlListItem"
              (click)="openFlowSummaryDialog()"
              [ngClass]="!canShowFlowSummary ? 'controlListItem_greyedOut inactive' : ''"
              [ngStyle]="{ visibility: displayFlowSummaryButton ? 'visible' : 'hidden' }"
            >
              <span class="controlListItem_iconBackground">
                  <img class="controlListItem_icon" src='../../../assets/svg/flow-ai-icon.svg' />
              </span>
              <span class="controlListItem_label">Flow Summary</span>
            </li>
            }

            @if (canEdit()) {
            <li
                                class="controlListItem"
                                (click)="showSubmitForApprovalDialog()"
                                [ngClass]="!canSubmitForApproval() || (isInternalUser() && isSingleApprover) ?  'controlListItem_greyedOut inactive' : ''"
                                [ngStyle]="{ visibility: displayApprovalButton ? 'visible' : 'hidden' }"
                        >
              <span class="controlListItem_iconBackground">
                <img class="controlListItem_icon" src='../../../assets/svg/approvals-icon.svg' />
              </span>
                            @if (!entityConfig?.['single-approver']) {
                                <span class="controlListItem_label">Submit for Approval</span>
                            } @else {
                                <span class="controlListItem_label">Deploy to Production</span>
                            }
                        </li>
            }
                    </ul>
                </div>
            </div>
            @if (activeMode === 'PREVIEW_MODE') {
            <div class="toolbar">
                <button class="stoppreview-btn preview-mode_btn" (click)="setFlowMode()">Stop preview</button>
            </div>
            }
            @if (!getIsModalOpen()) {
            <div
                    [ngClass]="{
        'dragArea-PreviewMode' : activeMode === 'PREVIEW_MODE' && isScrollZoom,
        'dragAreaFlexBox-previewMode' : activeMode === 'PREVIEW_MODE' && !isScrollZoom,
        'dragArea': isScrollZoom,
        'dragAreaFlexBox':  !isScrollZoom
        }"
                    id="dragArea"
                    (click)="resetSelectedNode()"
            >
                <ng-container>
                    <div
                            [ngClass]="activeMode === 'PREVIEW_MODE' ? 'drawAreaPreview' : 'drawArea'"
                            id="drawArea"
                            [hidden]="showCodeView"
                    >
                        @if (flowBuilderService.getFlowToDraw | async; as flow) {
                            <flow-drawer
                                #flowDrawer
                                [selectedNode]="selectedNode"
                                [flow]="flow"
                                [isScrollZoom]="isScrollZoom"
                                [addNewMenu]='activeMode === "FLOW_MODE" ? addNewMenu : null'
                                [copyAndMove]='activeMode === "FLOW_MODE" ? copyAndMove : null'
                                [pastContextMenu]='activeMode === "FLOW_MODE" ? pastContextMenu : null'
                                (resetSelectedNode)="resetSelectedNode()"
                                (nodeClick)="nodeClick($event, false)"
                                (addNewNode)="
                    addNewNode($event.nodeType, $event.nodeId, $event.stepType, $event.parentId, $event.extraFields)
                  "
                                (goToFlow)="goToFlow($event)"
                                (onNode)="onNode($event)"
                            ></flow-drawer>
                        } @else {
                            <loading-icon></loading-icon>
                        }
                    </div>
                </ng-container>
                @if (showCodeView) {
                <ngx-monaco-editor
                        id="codeEditor"
                        [options]="monacoOptions"
                        [(ngModel)]="codeText"
                        (ngModelChange)="onCodeChange()"
                        style="min-height: 500px; width: 100%; height: calc(100vh - 200px);"
                ></ngx-monaco-editor>
                }
            </div>
            }

            <div
                    id="bottom_toolBar"
                    [ngClass]="{ bottom_toolbar_flex: !isScrollZoom, bottom_toolbar: isScrollZoom, 'no-flow': getIsModalOpen() }"
            >
                <div class="toolbar_leftBox">
                    @if (activeMode !== 'PREVIEW_MODE') {
                    <recycle-bin
                            [deletedSteps]="this.flowBuilderService.getDeletedSteps"
                            [matMenu]="addNewMenu"
                            (nodeSelected)="nodeClick($event, true)"
                            (refreshRightSideBar)="resetSelectedNode()"
                    ></recycle-bin>
                    } @else {
                    <app-logs (toggleLogs)="toggleLogs($event)"></app-logs>
                    }
                </div>

                <div class="toolbar_rightBox">
                    @if (activeMode === 'PREVIEW_MODE') {
                    <div class='view-only-desc'>View only mode</div>
                    }

                    <div class="toolbar_zoom_group">
                        <div class="toolbar_zoom_container">
                            <button class="toolbar_zoom_decrease" (click)="zoomService.decreaseZoom()">-</button>
                            <div style="visibility: hidden" [matMenuTriggerFor]="zoomMenu"></div>
                            <button
                                    class="toolbar_zoom_lable"
                                    (click)="zoomService.resetZoom()"
                                    (contextmenu)="openZoomMenu($event)"
                            >
                                <span>{{ zoomService?.getZoomPercentage }}%</span>
                            </button>
                            <button class="toolbar_zoom_increase" (click)="zoomService.increaseZoom()">+</button>
                        </div>
                    </div>

                    <ul class="toolbar_controlList">
                        <li class="controlListItem" (click)="openSettingsAndShortcutsDialog()">
                <span class="controlListItem_iconBackground">
                  <img class="controlListItem_iconOnly" src='../../../assets/svg/keyboard_icon.svg' />
                </span>
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>
    </div>
    <right-sidebar
            (saveNode)="saveNodeClicked($event)"
            (deleteNode)="deleteNodeClicked($event)"
            (updateFlow)="updateFlow($event)"
            (resetNode)="resetSelectedNode()"
            [data]="stepData"
            [currentFlowSteps]="currentFlowSteps"
            [sideBarDisplay]="setSideBar"
            [displayMode]="isScrollZoom ? 'ScrollZoom' : 'normal'"
            [isRecycle]="isRecycleBinItem"
    >
    </right-sidebar>
</div>

<mat-menu #zoomMenu="matMenu" class="toolbar_zoom_menu">
    <button mat-menu-item (click)="zoomService.setZoom(50)">50%</button>
    <button mat-menu-item (click)="zoomService.setZoom(100)">100%</button>
    <button mat-menu-item (click)="zoomService.setZoom(150)">150%</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="zoomService.resetZoom()">Reset</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="toggleScrollZoom()">
        @if (isScrollZoom) {
        <mat-icon class="toolbar_zoom_scroll_icon">check_box</mat-icon>
        } @else {
        <mat-icon class="toolbar_zoom_scroll_icon">check_box_outline_blank</mat-icon>
        }
        <span>Scroll Zoom</span>
    </button>
</mat-menu>

<ng-template #saveExistingFlowDialog>
    <div class="flow_save_new">
        <div class="flow_save_new_title">
            Save changes to your flow "{{ flowTitle?.replace(',', '/') }}"?
        </div>
        <div class="flow_save_new_buttonsContainer">
            <button class="toolbar_saveBtn btnPrimary flow_save_new_delete" (click)="dontSaveFlow()">
                Don’t Save
            </button>
            <button class="toolbar_saveBtn btnPrimary flow_save_new_button" (click)="closeModal()">
                Cancel
            </button>
            <button class="toolbar_saveBtn btnPrimary flow_save_new_button" (click)="saveFlow(true)">
                Save
            </button>
        </div>
    </div>
</ng-template>

<ng-template #saveNewFlowDialog>
    <div class="flow_save_new">
        <div class="flow_save_new_title">Do you want to keep this New Flow?</div>
        <div class="flow_save_new_description">
            You can choose to save or delete this flow now. The name selected for this flow will not be
            editable after saving.
        </div>
        <div class="flow_save_new_saveAs">Save As:</div>
        <div class="flow_save_new_inputContainer">
            <input
                    class="flow_save_new_input"
                    [(ngModel)]="newFlowName"
                    name="newFlowName"
                    maxlength="100"
                    placeholder="[ New Flow ]"
            />
        </div>
        <div class="flow_save_new_buttonsContainer">
            <button class="toolbar_saveBtn btnPrimary flow_save_new_delete" (click)="dontSaveFlow()">
                Don’t Save
            </button>
            @if (this.requestFlowLoad === 'request' || this.requestRouteLoad === 'request') {
            <button
                    class="toolbar_saveBtn btnPrimary flow_save_new_delete"
                    (click)="dontSaveFlow()"
            >
                Delete
            </button>
            }
            <button class="toolbar_saveBtn btnPrimary flow_save_new_button" (click)="closeModal()">
                Cancel
            </button>
            <button
                    class="toolbar_saveBtn btnPrimary flow_save_new_button"
                    [disabled]="!newFlowName || savingInProgress"
                    (click)="createFlow(true)"
            >
                Save
            </button>
        </div>
    </div>
</ng-template>

<ng-template #alertDialog let-dialogRef="dialogRef">
    <div class="flow_alert_error">
        <h2 class="flow_alert_error_title">{{ alertTitle }}</h2>
        @if (alertText) {
        <div class="flow_alert_error_list">
            <ul>
                @for (line of alertText.split('\n'); track line) {
                <li>{{ line }}</li>
                }
            </ul>
        </div>
        }
        <div class="flow_alert_error_buttonsContainer">
            <button
                    class="toolbar_saveBtn btnPrimary flow_alert_error_button"
                    (click)="closeAlert()">
                OK
            </button>
        </div>
    </div>
</ng-template>


<ng-template #submitForApprovalDialog>
    <div class="flow_submitForApproval">
        <div class="flow_submitForApproval_title">
            Submit flow "{{ sharedService.getFlowName }}" for Approval
        </div>
        <div class="flow_submitForApproval_instructions">
            <div class="flow_submitForApproval_description">
                Please tell the approver what changed in the flow:
            </div>
            @if (approvalMessage.invalid && (approvalMessage.dirty || approvalMessage.touched)) {
            <span
                    class="flow_validationFailed flow_validationFailed_approvalMessage"
            >
        * required
      </span>
            }
        </div>

        <div class="flow_submitForApproval_message">
      <textarea
              required
              #textArea
              name="submitForApprovalMessage"
              #approvalMessage="ngModel"
              class="flow_submitForApproval_input"
              [(ngModel)]="submitForApprovalMessage"
      ></textarea>
        </div>
        <div class="flow_submitForApproval_buttonsContainer">
            <button
                    class="toolbar_saveBtn btnPrimary flow_save_new_delete"
                    (click)="closeSubmitForApprovalDialog()"
            >
                Don’t Submit
            </button>
            <button
                    class="toolbar_saveBtn btnPrimary flow_save_new_button"
                    (click)="submitForApproval(approvalMessage.invalid)"
            >
                Submit
            </button>
        </div>
    </div>
</ng-template>

<ng-template #resetFlowDialog>
    <div class="flow_save_new">
        <div class="flow_save_new_title">Reset node without saving?</div>
        <div class="flow_save_new_buttonsContainer">
            <button class="toolbar_saveBtn btnPrimary flow_save_new_button" (click)="closeModal()">
                Cancel
            </button>
            <button
                    class="toolbar_saveBtn btnPrimary flow_save_new_button"
                    (click)="resetSelectedNodeWithoutSaving()"
            >
                Reset
            </button>
        </div>
    </div>
</ng-template>

<ng-template #newNodeDialog>
    <div class="flow_save_new">
        <div class="flow_save_new_title">
            It looks like you have been editing something. If you leave before saving, your changes will
            be lost. Do you want to continue?
        </div>
        <div class="flow_save_new_buttonsContainer">
            <button
                    class="toolbar_saveBtn btnPrimary flow_save_new_button"
                    (click)="resetNewNodeWithoutSaving()"
            >
                Cancel
            </button>
            <button class="toolbar_saveBtn btnPrimary flow_save_new_button" (click)="dontSaveFlow()">
                Ok
            </button>
        </div>
    </div>
</ng-template>

<ng-template #addNextNode>
    <div class="flow_save_new">
        <div class="flow_save_new_title">
            It looks like you have been editing a node. If you add another node before saving, your changes will
            be lost. Do you want to continue?
        </div>
        <div class="flow_save_new_buttonsContainer">
            <button
                    class="toolbar_saveBtn btnPrimary flow_save_new_button"
                    (click)="closeModal()"
            >
                Cancel
            </button>
            <button class="toolbar_saveBtn btnPrimary flow_save_new_button" (click)="addNewNode(
                                                                                tempEventAddNode['nodeType'],
                                                                                tempEventAddNode['nodeId'],
                                                                                tempEventAddNode['stepType'],
                                                                                tempParentId,
                                                                                tempEventAddNode['extraFields'],
                                                                                true)"
            >
                Ok
            </button>
        </div>
    </div>
</ng-template>

<ng-template #settingsAndShortcutsDialog>
    <div class="flow_settingAndShortcuts">
        <div class="flow_settingAndShortcuts_title">
            <div class="flow_settingAndShortcuts_toolbar">
                <div class="flow_settingAndShortcuts_toolbar_title">Settings and Shortcuts</div>
                <button
                        class="flow_settingAndShortcuts_toolbar_close-button"
                        (click)="closeSettingsAndShortcutsDialog()"
                ></button>
            </div>
        </div>
        <div class="flow_settingAndShortcuts_content">
            <table>
                <tr class="table-row table-header">
                    <td class="col col-1">Action</td>
                    <td class="col col-2">Windows</td>
                    <td class="col col-3">Mac</td>
                </tr>
                <tr class="table-row">
                    <td class="col col-1">Jump to Search</td>
                    <td class="col col-2">
                        <span class="display-btn">Ctrl</span> + <span class="display-btn">F</span>
                    </td>
                    <td class="col col-3">
                        <span class="display-btn">⌘</span> + <span class="display-btn">F</span>
                    </td>
                </tr>
                <tr class="table-row">
                    <td class="col col-1">Zoom In</td>
                    <td class="col col-2"><span class="display-btn">+</span></td>
                    <td class="col col-3"><span class="display-btn">+</span></td>
                </tr>
                <tr class="table-row">
                    <td class="col col-1">Zoom Out</td>
                    <td class="col col-2"><span class="display-btn">-</span></td>
                    <td class="col col-3"><span class="display-btn">-</span></td>
                </tr>
                <tr class="table-row">
                    <td class="col col-1">Zoom 100%</td>
              <td class="col col-2">
                <span class="display-btn">Ctrl</span> + <span class="display-btn">0</span>
              </td>
              <td class="col col-3">
                <span class="display-btn">⌘</span> + <span class="display-btn">0</span>
                    </td>
                </tr>
                <tr class="table-row table-footer">
                    <td class="col col-1">Scroll to Zoom</td>
                    <td class="col col-2">
                        <!--                <div class="flow_settingAndShortcuts_checkbox" (click)='toggleScrollZoom()'>-->
                        <!--                    <img *ngIf="isScrollZoom" class="flow_settingAndShortcuts_checkbox_image" src="../../../assets/svg/checkbox-selected.svg"/>-->
                        <!--                    <img *ngIf="!isScrollZoom" class="flow_settingAndShortcuts_checkbox_image" src="../../../assets/svg/checkbox-default.svg" />-->
                        <!--                </div>-->
                        <input
                                type="checkbox"
                                id="flow_settingAndShortcuts_checkbox"
                                class="flow_settingAndShortcuts_checkbox"
                                (change)="toggleScrollZoom()"
                                [(ngModel)]="isScrollZoom"
                                name="isScrollZoom"
                        />
                        <label
                                for="flow_settingAndShortcuts_checkbox"
                                class="flow_settingAndShortcuts_label"
                        ></label>
                    </td>
                    <td class="col col-3"></td>
                </tr>
            </table>
        </div>
      </div>
    </ng-template>

    <mat-menu #addNewMenu="matMenu" #afterMenu="matMenu" xPosition="after">
      <ng-template matMenuContent let-id="id" let-parentId="parentId">
        @if (currentFlowType !== FlowType.ApiFlow && sharedService.getEntityType().toUpperCase() === 'CLIENT') {
          <button
            mat-menu-item
            [matMenuTriggerFor]="addNewUserFacingInteractionMenu"
            [matMenuTriggerData]="{ id: id, type: 'menu', parentId: parentId }"
            >
            User-Facing Nodes
          </button>
        }
        <button
          mat-menu-item
          [matMenuTriggerFor]="addNewActionMenu"
          [matMenuTriggerData]="{ id: id, type: 'action', parentId: parentId }"
          >
          Action Nodes
        </button>
        <button
          mat-menu-item
          [matMenuTriggerFor]="addIntegrationMenu"
          [matMenuTriggerData]="{ id: id, type: 'integration', parentId: parentId }"
          >
          Dynamic API Nodes
        </button>
        @if (hasChatHubData && chatHubData[0]?.type !== 'error') {
          <button
            mat-menu-item
            [matMenuTriggerFor]="addChatHubMenu"
            [matMenuTriggerData]="{ id: id, type: 'action', parentId: parentId }"
            >
            Integration Nodes
          </button>
        }
        @if (flowBuilderService.getOperationState) {
          <button
            mat-menu-item
            (click)="flowBuilderService.paste(id, parentId)"
            >
            Paste
          </button>
        }
      </ng-template>
    </mat-menu>

<mat-menu #addNewActionMenu="matMenu">
  <ng-template matMenuContent let-id="id" let-type="type" let-parentId="parentId">
    @for (action of actionNodeTypes | async; track action) {
      @if (action.show !== false) {
      <button
              mat-menu-item
              (click)="addNewNode(action.nodeType, id, type, parentId, action.extraFields)"
      >
        {{ action.title }}
      </button>
      }
    }
  </ng-template>
</mat-menu>

<mat-menu #addNewUserFacingInteractionMenu="matMenu">
  <ng-template matMenuContent let-id="id" let-type="type" let-parentId="parentId">
    @for (node of menuNodeTypes | async; track node) {
    <button
      mat-menu-item
      (click)="addNewNode(node.nodeType, id, type, parentId, node.extraFields)"
    >
      {{ node.title }}
    </button>
    }
  </ng-template>
</mat-menu>

<mat-menu #addIntegrationMenu="matMenu">
  <ng-template matMenuContent let-id="id" let-type="type" let-parentId="parentId">
    @for (integration of integrationsNodeTypes | async; track integration) {
      <button
        mat-menu-item
        (click)="addNewNode(integration.nodeType, id, type, parentId, integration.extraFields)"
      >
        {{ integration.title }}
      </button>
    }
  </ng-template>
</mat-menu>

<mat-menu #addChatHubMenu="matMenu">

  <ng-template matMenuContent let-id="id" let-type="type" let-parentId="parentId">
      @for (node of chatHubData; track node) {
      <button
              mat-menu-item
              (click)="addNewNode(node.nodeType, id, type, parentId, node.extraFields)"
      >
      {{ node.title }}
      </button>
    }
  </ng-template>
</mat-menu>

<mat-menu #copyAndMove="matMenu" class="toolbar_zoom_menu">
    <ng-template matMenuContent let-stepId="stepId" let-parentId="parentId" let-isNew="isNew">
        @if (!isNew) {
            <button mat-menu-item (click)="flowBuilderService.copy(stepId, parentId)">Copy</button>
            <button mat-menu-item (click)="flowBuilderService.cut(stepId, parentId)">Cut</button>
        }
    </ng-template>
</mat-menu>

<mat-menu #pastContextMenu="matMenu" class="toolbar_zoom_menu">
  <ng-template matMenuContent let-stepId="stepId" let-parentId="parentId">
    @if (sharedService.getEnvironment() != 'prod' && flowBuilderService.getOperationState) {
    <button
            mat-menu-item
            (click)="flowBuilderService.paste(stepId, parentId)"
    >
      Paste
    </button>
    }
  </ng-template>
</mat-menu>

<saving-in-progress [showSavingInProgress]="savingInProgress"></saving-in-progress>


<ng-template #recycleBinClearNodesDialog>
    <div class="flow_ClearNodesDialog">
        <div class="flow_ClearNodesDialog_header">
            <div class="flow_ClearNodesDialog_toolbar">
                <div class="flow_ClearNodesDialog_toolbar_title">
                    <span>Clearing Node</span>
                </div>
                <button
                        class="flow_ClearNodesDialog_toolbar_close-button"
                        (click)="closeRecycleBinClearNodesDialog()"
                ></button>
            </div>
        </div>
        <div class="flow_ClearNodesDialog_message">
            <div>
                <img
                        class="flow_ClearNodesDialog_message_image"
                        src='../../../assets/svg/redesign/ExclamationMark_Red.svg'
                />
            </div>
            <div class="flow_ClearNodesDialog_message_text">
                Clearing nodes from the recycle bin are not recoverable. Continue with clear?
            </div>
        </div>
        <div class="flow_ClearNodesDialog_buttonsArea">
            <button
                    class="flow_ClearNodesDialog_buttonsArea_cancel"
                    (click)="closeRecycleBinClearNodesDialog()"
            >
                Cancel
            </button>
            <button class="flow_ClearNodesDialog_buttonsArea_clear" (click)="clearNodesClick()">
                Clear
            </button>
        </div>
    </div>
</ng-template>

      <ng-template #previewModeToolbar>
        <div class="toolbar preview-mode_topbar">
          <button class="stoppreview-btn preview-mode_btn" (click)="setFlowMode()">Stop preview</button>
        </div>
      </ng-template>

      <ng-container #viewcontainer></ng-container>
      <ng-template>
        <app-confirmation-popup #child></app-confirmation-popup>
      </ng-template>

      @if (this.activeMode === 'SEARCH_MODE') {
        <app-left-search-bar #findAndReplace
          (onClick)="searchItemClicked($event)"
          (onClose)="closeSearch()"
          (onReplace)="onReplace($event)"
          (onReplaceAll)="onReplaceAll($event)"
          (onUndoAll)="onReplaceAll($event)">
        </app-left-search-bar>
      }

<!-- Flow Summary Sidebar -->
<flow-summary-sidebar
  [isVisible]="isFlowSummarySidebarVisible"
  (closeSidebarEvent)="closeFlowSummarySidebar()">
</flow-summary-sidebar>

<app-left-sidebar (openTemplateEvent)="openTemplateModal()"></app-left-sidebar>

@if (showTemplateModal) {
<flow-step-selection
        [selectedValue]="{ selected: pendingSelection, step: pendingSelectionStep }"
        [botId]="sharedService.getEntityId()"
        [disableFilter]="false"
        [templateMode]="templateMode"
        [isUserInternal]="isInternalUser()"
        [tryBuild]="tryBuild"
        (closeModal)="onFlowStepSelectionClose($event)"
></flow-step-selection>
}